import { reduce } from 'lodash/fp';

import { TravellerAgeDetails } from '../../types';
import uncapFpIterator from '../../../../../../../../../utils/uncap-fp-iterator';

type TravellerAgeFields = {
  [key: string]: string;
};

const ADULT_AGE = 18;

const getMaximumChildrenAndAdults = (travellerAgeFields: TravellerAgeFields): TravellerAgeDetails => {
  const defaultValue = {
    amountOfAdults: 0,
    amountOfChildren: 0,
    indexOfAdultMaxAge: null,
    indexOfChildrenMaxAge: null,
  };
  return uncapFpIterator(reduce)(
    (result: TravellerAgeDetails, value: string, key: string) => {
      const fieldIndex = Number(key.split('_')[1]);
      const ageInt = Number(value);
      if (ageInt >= ADULT_AGE) {
        return { ...result, amountOfAdults: result.amountOfAdults + 1, indexOfAdultMaxAge: fieldIndex };
      }
      if (ageInt < ADULT_AGE) {
        return { ...result, amountOfChildren: result.amountOfChildren + 1, indexOfChildrenMaxAge: fieldIndex };
      }

      return result;
    },
    defaultValue,
    travellerAgeFields,
  );
};

export default getMaximumChildrenAndAdults;
